import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../common/app.settings';
import 'rxjs/add/operator/map';

import { ContentHeaders } from '../common/headers';
import { Group } from '../models/group.model';
import { ApiResult } from '../models/apiresult.model';

@Injectable()
export class GroupService {
    constructor(
        private http: Http,
        private contentHeaders: ContentHeaders) {
    }

    getGroups(): Promise<Group[]> {
        // get users from api
        return this.http.get(AppSettings.apiEndPoint + '/group/GetGroups', { headers: this.contentHeaders.headers })
            .map((response: Response) => {
                return response.json();
            })
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    getGroup(groupId: string): Promise<Group> {
        return this.http.get(
            AppSettings.apiEndPoint + '/Group/' + groupId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    updateGroup(group: Group): Promise<ApiResult> {
        return this.http.put(
            AppSettings.apiEndPoint + '/Group/' + group.id,
                JSON.stringify(group),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    addGroup(group: Group): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + '/Group/',
                JSON.stringify(group),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    deleteGroup(groupId: string): Promise<ApiResult> {
        return this.http.delete(
            AppSettings.apiEndPoint + '/Group/' + groupId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    private handleErrorPromise(error: any): Promise<void> {
        try {
            error = JSON.parse(error._body);
        } catch (e) {
        }

        const errMsg = error.errorMessage
            ? error.errorMessage
            : error.message
            ? error.message
            : error._body
            ? error._body
            : error.status
            ? `${error.status} - ${error.statusText}`
            : 'unknown server error';

        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/group.service.ts